module.exports = __webpack_public_path__ + "static/media/NaranjaPng.a6722d2a.png";